import quoteAxios from '@/services/axiosQuoteApi'

export const state = {
  premises: [],
}

export const actions = {
  async fetchPremises ({ commit }, { quoteId }) {
    await quoteAxios
      .get(`/quote/${quoteId}/contact/premises`)
      .then((response) => {
        commit('setPremises', response.data.data)

        commit('setPremises', this.getters['premises/all'], {
          root: true,
        })

        return response.data.data
      })
      .catch((error) => {
        throw error
      })
  },
  async storePremises ({ commit }, { quoteId, formData }) {
    await quoteAxios
      .post(`/quote/${quoteId}/contact/premises`, formData)
      .then((response) => {
        commit('addPremises', response.data.data)
        commit('setPremises', this.getters['premises/all'], {
          root: true,
        })

        return response.data.data
      })
      .catch((error) => {
        throw error
      })
  },
  async deletePremises ({ commit }, { quoteId, premisesId }) {
    await quoteAxios
      .delete(`/quote/${quoteId}/contact/premises/${premisesId}`)
      .then((response) => {
        commit('removePremises', response.data.data)
        commit('setPremises', this.getters['premises/all'], {
          root: true,
        })

        return response.data.data
      })
      .catch((error) => {
        throw error
      })
  },
}
export const getters = {
  all: state => state.premises || [],
}

export const mutations = {
  setPremises (state, premises) {
    state.premises = premises
  },
  addPremises (state, premises) {
    state.premises.push(premises)
  },
  removePremises (state, premises) {
    const index = state.premises.findIndex(premisesState => premisesState._id === premises._id)
    state.premises.splice(index, 1)
  },
}
